/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
/* GIOLA: Gratis Kontrollkamm beim Anti-Knoten-Rundum-Set */

(() => {
  const RUNDUM_SET_VARIANT_ID = 55991471505673;
  const KONTROLLKAMM_VARIANT_ID = 57334532735241;

  const originalFetch = window.fetch.bind(window);

  let isSyncingGift = false;

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    return response.json();
  }

  async function addGift() {
    await originalFetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: KONTROLLKAMM_VARIANT_ID,
            quantity: 1,
            properties: {
              _giola_free_gift: 'Kontrollkamm'
            }
          }
        ]
      })
    });
  }

  async function removeGift(giftItem) {
    await originalFetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0
      })
    });
  }

  async function refreshGiolaCartDrawer() {
    try {
      const response = await originalFetch('/cart?section_id=api-cart-items');
      const html = await response.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newLineItems = doc.querySelector('[data-api-line-items]');
      const currentLineItems = document.querySelector('[data-items-holder]');

      if (newLineItems && currentLineItems) {
        currentLineItems.innerHTML = newLineItems.innerHTML;
        currentLineItems.classList.remove('hidden');
      }

      const newTotal = doc.querySelector('[data-cart-total]');
      const currentTotal = document.querySelector('[data-cart-total]');

      if (newTotal && currentTotal) {
        currentTotal.innerHTML = newTotal.innerHTML;
      }

      const cart = await getCart();

      const cartCount = document.querySelector('[data-cart-items-qty]');

      if (cartCount) {
        cartCount.textContent =
          cart.item_count === 1
            ? '1 Gegenstand'
            : `${cart.item_count} Gegenstände`;
      }

      const cartIconCount =
        document.querySelector('[data-cart-count]') ||
        document.querySelector('.cart-count') ||
        document.querySelector('[data-cart-item-count]');

      if (cartIconCount) {
        cartIconCount.textContent = cart.item_count;
      }
    } catch (error) {
      console.error('Giola Cart Drawer Refresh Error:', error);
    }
  }

  async function syncFreeGift() {
    if (isSyncingGift) return;

    isSyncingGift = true;

    try {
      const cart = await getCart();

      const hasRundumSet = cart.items.some(
        item => Number(item.variant_id) === RUNDUM_SET_VARIANT_ID
      );

      const giftItem = cart.items.find(
        item =>
          Number(item.variant_id) === KONTROLLKAMM_VARIANT_ID &&
          item.properties &&
          item.properties._giola_free_gift === 'Kontrollkamm'
      );

      if (hasRundumSet && !giftItem) {
        await addGift();
        await refreshGiolaCartDrawer();
      }

      if (!hasRundumSet && giftItem) {
        await removeGift(giftItem);
        await refreshGiolaCartDrawer();
      }
    } catch (error) {
      console.error('Giola Free Gift Error:', error);
    } finally {
      isSyncingGift = false;
    }
  }

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const requestUrl =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    if (
      requestUrl.includes('/cart/add') ||
      requestUrl.includes('/cart/change') ||
      requestUrl.includes('/cart/update') ||
      requestUrl.includes('/cart/clear')
    ) {
      setTimeout(syncFreeGift, 400);
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(syncFreeGift, 300);
  });
})();